import { render, staticRenderFns } from "./ManageProductCategory.vue?vue&type=template&id=38992a3f"
import script from "./ManageProductCategory.vue?vue&type=script&lang=js"
export * from "./ManageProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports